// The output of a listener is never used
type Listener<V> = (value: V) => unknown;

/**
 * A publish-subscribe channel with only a single listener at any time
 */
export class UnicastChannel<V> {
  listener: Listener<V> | null | undefined;

  /**
   * Subscribe listener to channel. Throw away previous listener, if any.
   */
  subscribe: (listener: Listener<V>) => void = listener => {
    this.listener = listener;
  };

  /**
   * Publish a value to the current listener.
   */
  publish: (value: V) => void = value => {
    this.listener && this.listener(value);
  };
}

export function createUnicastChannel<V>(): UnicastChannel<V> {
  return new UnicastChannel();
}
